import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import classnames from 'classnames';
import { Breadcrumbs } from '@fiverr-private/fit';
import { THEMES } from './constants';
import classes from './style.module.scss';

/**
 * A wrapper of fit's <Breadcrumbs/> component, with our theme styling.
 * @param <Array<{ name: String, url: String }>> list - A list of navigation items.
 * @param <String> theme - A dark one for dark backgrounds. Would use default <Breadcrumbs/>'s UI for light theme.
 * @return {JSX.Element}
 */
const BreadcrumbsWrapper = ({ list = [], theme = THEMES.LIGHT, separatorClassName }) => (
    <Breadcrumbs
        className={classnames(classes.breadcrumbs, classes[`theme-${theme}`])}
        separatorClassName={classnames(classes.separator, separatorClassName)}
    >
        {list.map(({ url, name }, i) => (
            <Breadcrumbs.Crumb key={i}>
                {i === list.length - 1 ? (
                    <p className={classnames(classes.breadcrumb, classes.breadcrumbText)}>{name}</p>
                ) : (
                    <a className={classnames(classes.breadcrumb, classes.breadcrumbLink)} href={url}>
                        {name}
                    </a>
                )}
            </Breadcrumbs.Crumb>
        ))}
    </Breadcrumbs>
);

BreadcrumbsWrapper.propTypes = {
    list: arrayOf(
        shape({
            name: string,
            url: string,
        })
    ),
    theme: string,
    separatorClassName: string,
};

Object.assign(BreadcrumbsWrapper, {
    THEMES,
});

export default BreadcrumbsWrapper;
